import { render, staticRenderFns } from "./CampaignInfoConfig2.vue?vue&type=template&id=24f28cee&scoped=true&"
import script from "./CampaignInfoConfig2.vue?vue&type=script&lang=js&"
export * from "./CampaignInfoConfig2.vue?vue&type=script&lang=js&"
import style0 from "./CampaignInfoConfig2.vue?vue&type=style&index=0&id=24f28cee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f28cee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VForm,
  VSelect,
  VTextField,
})
